module.exports = __webpack_public_path__ + "img/taiwanRailway-1.71a13352.jpg";